import { render, staticRenderFns } from "./MassenAnmeldungModal.vue?vue&type=template&id=64e6410c"
import script from "./MassenAnmeldungModal.vue?vue&type=script&lang=js"
export * from "./MassenAnmeldungModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports